import { withStyles } from '@material-ui/core/styles';
import FixedButton from './FixedButton';
import styles from './FixedButton.styles';

export default withStyles(styles)(FixedButton);
